<template>
    <div class="release">
        <div class="title">
            <el-breadcrumb >
                <el-breadcrumb-item :to="{ path: '/home/coupon' }">券列表</el-breadcrumb-item>
                <el-breadcrumb-item>发券</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main warp">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="left" v-loading="formLoad">
                <el-form-item label="名称" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="券名称"></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <el-radio-group v-model="ruleForm.type">
                        <!-- <el-radio label="1">优惠券</el-radio> -->
                        <el-radio label="2">满减券</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="面额" prop="amount" class="amount">
                    <el-input v-show="ruleForm.type == 1" v-model="ruleForm.amount" placeholder="金额（元）"></el-input>
                    <div v-show="ruleForm.type == 2">
                        <span style="margin-right: 15px">满</span><el-input v-model="ruleForm.spending_amount" placeholder="金额（元）" style="width: 150px; margin-right: 30px"></el-input>
                        <span style="margin-right: 15px">减</span><el-input v-model="ruleForm.off_amount" placeholder="金额（元）" style="width: 150px"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="有效时间" prop="date">
                    <el-date-picker
                        style="width: 100%"
                        v-model="ruleForm.date"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="expireTimeOption"
                        @change="handleDate"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="每人限领" prop="each_limit">
                    <el-select v-model="ruleForm.each_limit" style="width: 100%">
                        <el-option label="1" value="1"></el-option>
                        <el-option label="2" value="2"></el-option>
                        <el-option label="3" value="3"></el-option>
                        <el-option label="4" value="4"></el-option>
                        <el-option label="5" value="5"></el-option>
                        <el-option label="6" value="6"></el-option>
                        <el-option label="7" value="7"></el-option>
                        <el-option label="8" value="8"></el-option>
                        <el-option label="9" value="9"></el-option>
                        <el-option label="10" value="10"></el-option>
                        <el-option label="不限制" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="使用限制" prop="limit">
                    <el-select v-model="ruleForm.limit" style="width: 100%">
                        <el-option label="不与其他券叠加使用（除积分兑换券）" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="发放数量" prop="number" class="price">
                    <el-input v-model="ruleForm.number" placeholder="张数"></el-input>
                </el-form-item>
                <el-form-item label="关联商品" prop="goods_mains_ids">
                    <el-button size="mini" @click="selProduct(true)">{{ isCheck ? "查看关联商品" : "选择商品" }}</el-button>
                </el-form-item>
                <el-form-item label="">
                    <p style="color: red">说明：营销活动不可用</p>
                </el-form-item>
            </el-form>
            <div class="btnList">
                <el-button size="medium" @click="back">{{ isCheck ? "返回" : "取消" }} </el-button>
                <el-button size="medium" v-if="!isCheck" @click="couponskindCreateFunc" :loading="btnLoad">保存</el-button>
            </div>
        </div>
        <div class="dialog">
            <el-dialog title="关联商品" :visible.sync="dialogVisible" width="1200px">
                <products
                    ref="refPro"
                    @closeDia="dialogVisible = false"
                    @getIdList="bindId"
                    :treeData="treeData"
                    @treeShow="treeDialog = true"
                    :goods_mains_ids="ruleForm.goods_mains_ids"
                    :isCheck="isCheck"
                ></products>
            </el-dialog>
        </div>
        <div class="tree">
            <el-dialog title="商品分类" :visible.sync="treeDialog" width="576px">
                <el-tree class="mytree" :data="treeData" show-checkbox node-key="id" :props="defaultProps" @check="currentChecked" accordion> </el-tree>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="treeDialog = false">取 消</el-button>
                    <el-button type="primary" @click="treeSeach">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import products from "./products.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            formLoad: false,
            deadline: "", // 截止时间
            btnLoad: false,
            dialogVisible: false,
            treeDialog: false,
            ruleForm: {
                title: "",
                type: "2",
                amount: "",
                spending_amount: "",
                off_amount: "",
                date: [],
                each_limit: "",
                limit: "",
                number: "",
                goods_mains_ids: [],
            },
            rules: {
                title: [{ required: true, message: "请输入券名称", trigger: "blur" }],
                type: [{ required: true, message: "请选择券类型", trigger: "blur" }],
                date: [{ required: true, message: "请选择时间", trigger: "blur" }],
                each_limit: [{ required: true, message: "请选择领券数量", trigger: "blur" }],
                // amount: [{ required: true, message: "请输入金额", trigger: "" }],

                limit: [{ required: true, message: "请选择使用限制", trigger: "blur" }],
                number: [{ required: true, message: "请输入发放数量", trigger: "blur" }],
                goods_mains_ids: [{ required: true, message: "请选择关联商品", trigger: "" }],
            },
            treeData: [],
            checkedList: [],
            defaultProps: {
                children: "children",
                label: "name",
            },
            isCheck: !!this.$route.query.id,
            page: null,
        };
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    components: { products },
    created() {
        this.getTreeDate();
        if (this.$route.query.id) {
            this.couponskindDetailFunc();
        }
        if (this.$route.query.page) {
            this.page = this.$route.query.page;
        }
    },
    methods: {
        ...mapActions({
            getGoodLei: "commodity/getGoodLei",
            couponskindCreate: "commodity/couponskindCreate",
            couponskindDetail: "commodity/couponskindDetail",
        }),
        handleDate(value) {
            this.deadline = value;
        },
        async couponskindDetailFunc() {
            try {
                this.formLoad = true;
                let opt = {
                    token: this.getToken,
                    id: this.$route.query.id,
                };
                let res = await this.couponskindDetail(opt);
                // console.log(res);
                if (res.code != 1) {
                    this.$message.error(res.msg);
                }
                let obj = JSON.parse(JSON.stringify(res.data));
                this.ruleForm = obj;
                this.ruleForm.date = [];
                this.ruleForm.date[0] = obj.able_start_time;
                this.ruleForm.date[1] = obj.able_end_time;
                this.ruleForm.limit = "1";
                // console.log(this.ruleForm.date);
            } catch (err) {
                console.log(err);
            } finally {
                this.formLoad = false;
            }
        },
        couponskindCreateFunc() {
            if (this.ruleForm.goods_mains_ids.length == 0) {
                return this.$message.warning("请选择关联商品");
            }
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    try {
                        this.btnLoad = true;
                        let opt = {
                            token: this.getToken,
                            title: this.ruleForm.title, //券名称
                            type: Number(this.ruleForm.type), //券类型  1 优惠券  2满减券
                            amount: this.ruleForm.type == 1 ? this.ruleForm.amount : null, //面值
                            spending_amount: this.ruleForm.type == 2 ? this.ruleForm.spending_amount : null, //满x元
                            off_amount: this.ruleForm.type == 2 ? this.ruleForm.off_amount : null, //减x元
                            able_start_time: this.ruleForm.date ? this.ruleForm.date[0] : null, //使用开始时间
                            able_end_time: this.ruleForm.date ? this.ruleForm.date[1] : null, //使用结束时间
                            each_limit: this.ruleForm.each_limit, //每人限领券多少张  0代表不限制
                            number: this.ruleForm.number, //发放数量
                            goods_mains_ids: this.ruleForm.goods_mains_ids.toString(), //勾选的商品id
                        };
                        // console.log(opt);
                        let res = await this.couponskindCreate(opt);
                        // console.log(res);
                        if (res.code != 1) {
                            return this.$message.error(res.msg);
                        }
                        this.$message.success("创建成功！");
                        this.back();
                    } catch (err) {
                        console.log(err);
                    } finally {
                        this.btnLoad = false;
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        currentChecked(data, currentChecked) {
            const { checkedNodes } = currentChecked;
            if (checkedNodes.length == 0) {
                this.checkedList = [];
            } else {
                let listId = [];
                checkedNodes.forEach((element) => {
                    listId.push(element.id);
                    this.checkedList = Array.from(new Set(listId));
                });
            }
            // console.log(this.checkedList);
        },
        treeSeach() {
            this.treeDialog = false;
            this.$nextTick(() => {
                this.$refs.refPro.initList();
            });
            this.$refs.refPro.bind(this.checkedList);
        },
        async getTreeDate() {
            let opt = {
                token: this.getToken, //必填  商家token
                classifys_type_id: 2000, //非必填   2000 实体  2001 虚拟
            };
            let res = await this.getGoodLei(opt);
            // console.log(res);
            if (res.code != 1) {
                return this.$message.error(res.msg);
            }
            this.treeData = res.data.treeData;
        },
        bindId(list) {
            console.log(list);
            if (list && list.length != 0) {
                this.ruleForm.goods_mains_ids = list;
            } else {
                this.ruleForm.goods_mains_ids = [];
            }
            this.dialogVisible = false;
            // console.log(this.ruleForm.goods_mains_ids);
        },
        back() {
            if (this.page) {
                this.$router.push({
                    name: "coupon",
                    params: { page: this.page },
                });
            } else {
                this.$router.push({
                    path: "/home/coupon",
                });
            }
        },
        selProduct(f) {
            this.dialogVisible = true;
        },
    },
};
</script>

<style lang='scss' scoped>
.btnList {
    margin-top: 80px;
    display: flex;
    justify-content: center;
    .el-button {
        width: 100px;
        margin: 0 20px;
    }
}
.release {
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        font-size: 20px;
        align-items: center;
        a {
            text-decoration: none;
        }
        p {
            font-size: 18px;
            color: #333;
            margin-left: 0;
        }
    }

    .main {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        background: #fff;
        margin-top: 24px;
        padding: 20px 10px;
        padding-bottom: 70px;
        min-height: 700px;
        min-width: 1200px;
        .el-form {
            width: 500px;
            margin: 60px auto;
        }
    }
}
.mytree {
    height: 500px;
    overflow-y: auto;
}

.amount {
    ::v-deep .el-form-item__label {
        &::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
        }
    }
}

.price {
    position: relative;
    .txt {
        position: absolute;
        right: -28px;
    }
}
</style>